module.exports = __webpack_public_path__ + "img/icon_header_user_w.2f7f49e0.svg";